const STORAGE_KEY = "post-login-redirect";

export const setPostLoginRedirect = (rawUrl: string) => {
  try {
    const url = new URL(rawUrl, globalThis.location.origin);
    if (url.origin !== globalThis.location.origin) return;
    globalThis.sessionStorage.setItem(STORAGE_KEY, url.toString());
  } catch {
    // ignore
  }
};

export const getPostLoginRedirect = (): string | null => {
  try {
    return globalThis.sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const consumePostLoginRedirect = (): string | null => {
  const value = getPostLoginRedirect();
  try {
    globalThis.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  return value;
};
